module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pressEnterToAdd":"Press Enter to add"},"fr":{"pressEnterToAdd":"Appuyez sur Entrée pour ajouter"}}')
  delete Component.options._Ctor
}
